<template>
    <i class="i-ph-caret-right"/>
    <dropdown-menu>
        <template #button>
            <div class="crumb cursor-pointer" data-cy="breadcrumb-reports">
                <i class="i-ph-chart-bar-fill"/>Rapporter
            </div>
        </template>
        <template #dropdown="{ close }">
            <lazy-reports-menu :close="close" class="p-2" />
        </template>
    </dropdown-menu>
</template>

<script setup lang="ts">

import DropdownMenu from '@/components/DropdownMenu.vue'
import {defineAsyncComponent} from 'vue'
const LazyReportsMenu = defineAsyncComponent(
    () => import('@/components/reports/ReportsMenu.vue')
)
</script>

<style scoped>

</style>